import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CKEditor from "react-ckeditor-component";
import renderHTML from "react-render-html";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { get_static_page_details } from "../../../redux/actions/termsPolicyAndContactActions";
import loader from "../../../style/loader/loader.scss";
import Cookies from 'universal-cookie';

import languageConfig from "../../../config/languageConfig";
const cookies = new Cookies();

const history = createBrowserHistory();
class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "Settings", "Manage Terms Contact And Policy"],
      msgType: "",
      alertMessage: "",
      show: "",
      multi_lang: 'no',
      lang: '',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en')
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
    this.props.get_static_page_details({lang: lang});
  }

  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
    this.props.get_static_page_details({lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      if(siteData){
      if(siteData.multi_lang == "yes"){
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }
    //this.props.get_static_page_details({lang: (siteData.default_lang) ? siteData.default_lang : this.state.lang});
    this.props.get_static_page_details({lang: this.state.default_lang});
  
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.language){
      if(this.state.default_lang !== nextProps.language){
        this.setState({default_lang: nextProps.language});
        this.props.get_static_page_details({lang: nextProps.language});
      }
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);

      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,

        });
      }
    }
  }

  render() {
    return (
      <div>
        {this.props.staticPageDetails &&
        this.props.staticPageDetails.contactUs ? (
          <div className="container">
            {this.props.fetchingDetails ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div>
              <div className="row">
                {this.state.show &&
                  this.state.alertMessage !== "" &&
                  this.state.msgType && (
                    <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
              </div>
              {this.props.staticPageDetails &&
              this.props.staticPageDetails.contactUs ? (
                <div className="panel" style={{ marginTop: "40px" }}>
                  <header className="panel-heading">{languageConfig[this.state.default_lang].contact_us}</header>
                  <div className="panel-body">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <Row>
                        <Col md={8} xs={12} mdOffset={2}>
                          <Row>
                            <Col md={12} xs={12}>
                              <div>
                                {renderHTML(
                                  this.props.staticPageDetails.contactUs
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="panel" style={{ marginTop: "40px" }}>
                  <header className="panel-heading">Contact Us</header>
                  <div className="panel-body">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <Row>
                        <Col md={8} xs={12} mdOffset={2}>
                          <Row>
                            <Col md={12} xs={12}>
                              <div style={{ textAlign: "center" }}>
                                Content is not available
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

ContactUs.propTypes = {
  get_static_page_details: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  staticPageDetails: state.termsPolicyAndContactReducer.staticPageDetails,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.termsPolicyAndContactReducer.error,
  fetchingDetails: state.termsPolicyAndContactReducer.fetchingDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_static_page_details, clearAlert, renderAlert })
)(ContactUs);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/ContactUs.js